/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { unitSchema } from "../unitSchema.ts";
import { z } from "zod";

/**
 * @description Успешно
 */
export const deleteApiTracksJob200Schema = z.lazy(() => unitSchema)

/**
 * @description Ошибка валидации запроса | Неправильный запрос
 */
export const deleteApiTracksJob400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const deleteApiTracksJob401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const deleteApiTracksJob403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const deleteApiTracksJob500Schema = z.lazy(() => badResponseModelSchema)

export const deleteApiTracksJobMutationResponseSchema = z.lazy(() => deleteApiTracksJob200Schema)